var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresentationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_37996",
    "data-name": "Group 37996",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.444,
    height: 31.948,
    viewBox: "0 0 34.444 31.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    d: "M25.833,0l8.611,15.974L25.833,31.948H8.611L0,15.974,8.611,0Z",
    transform: "translate(0 0)",
    fill: "#8332c9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_932_",
    transform: "translate(9.964 8.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_939_",
    d: "M248.438,15.549h-6.164a.326.326,0,0,0-.326.326v2.334l.637-.944.015-.021V16.2h5.512v7.665H242.6V20.941a1.773,1.773,0,0,1-.33.289c-.369.547-.3.44-.322.475v2.487a.326.326,0,0,0,.326.326h1.54l-.9,2.282a.473.473,0,0,0,.879.348l1.04-2.63h1.051l1.04,2.63a.473.473,0,1,0,.879-.348l-.9-2.282h1.54a.326.326,0,0,0,.326-.326V15.875A.326.326,0,0,0,248.438,15.549Z",
    transform: "translate(-234.342 -15.047)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_947_",
    d: "M250.2,77.486l.932-1.382a.326.326,0,0,0-.54-.365l-.928,1.376A1.171,1.171,0,0,1,250.2,77.486Z",
    transform: "translate(-241.812 -73.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_949_",
    cx: 1.22,
    cy: 1.22,
    rx: 1.22,
    ry: 1.22,
    transform: "translate(1.778 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_950_",
    d: "M14.143,89.611a.588.588,0,0,0-.81-.19l-1.192.74c0-.39,0-.694-.006-1.1a1.4,1.4,0,0,0-1.393-1.386H7.577a1.4,1.4,0,0,0-1.393,1.386l-.022,4.324a.588.588,0,0,0,.586.591h0a.589.589,0,0,0,.588-.586l.022-4.324h0a.117.117,0,0,1,.234,0v9.892a.706.706,0,1,0,1.412,0V93.467a.152.152,0,1,1,.3,0V98.96a.706.706,0,1,0,1.412,0c-.014-9.477-.013-8.226-.013-9.891a.123.123,0,0,1,.246,0h0c0,.573.009,1.8.011,2.152a.589.589,0,0,0,.9.5l2.086-1.295A.589.589,0,0,0,14.143,89.611Z",
    transform: "translate(-6.163 -84.847)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationIcon);
export default __webpack_public_path__ + "static/media/presentationIcon.5c5306775197b083c2ce6568b2017dfc.svg";
export { ForwardRef as ReactComponent };